import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip'; 
import TestPatternSave from './TestPatternSave';
import TestPatternDetails from './TestPatternDetails';
import TestPatternSections from './TestPatternSections';
import TestPatternDefinations from './TestPatternDefinations';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';

  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isadminloggedin'); 
	const childRefNewSave = React.useRef();
	const childRefDetails = React.useRef();
	const childRefSections = React.useRef();
	const childRefDefinations = React.useRef();
	const childRefAuthorization = React.useRef();
	const [pageLoading, setPageLoading] = React.useState(true);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [clone, setClone] = React.useState(false);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [selectedRow, setSelectedRow] = React.useState(0);	
	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(74);
	const pageSize = 100;
	
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [privileges, setPrivileges] = React.useState("");

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'srno', headerName: 'Sr. No.', width: 40 },
		{ field: 'patternTitle', headerName: 'Pattern Title', width: 350, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'patternDescription', headerName: 'Description', width: 350, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'treeviewTemplateTitle', headerName: 'Treeview', width: 350, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'examType', headerName: 'Exam Type', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'totalTime', headerName: 'Total Time', width: 200},
		{ field: 'sectionAllow', headerName: 'Section Allow', width: 200, renderCell: (params) =>  (
			<span>{params.value===1?<>Yes</>:<>No</>}</span>
		   ), },
		// { field: 'marksCorrectAns', headerName: 'Marks Correct Ans', width: 200},
		// { field: 'marksIncorrectAns', headerName: 'Marks Incorrect Ans', width: 200},
		// { field: 'marksNotAns', headerName: 'Marks Not Ans', width: 200},
		// { field: 'maxQuestionAttempt', headerName: 'Max Question Attempt', width: 200},
		{ field: 'lastYearMin', headerName: 'Last Year Min', width: 200},
		{ field: 'lastYearMax', headerName: 'Last Year Max', width: 200},
		{ field: 'smeBenchmarkMin', headerName: 'SME Benchmark Min', width: 200},
		{ field: 'smeBenchmarkMax', headerName: 'SME Benchmark Max', width: 200},
		{ field: 'approxBenchmarkMin', headerName: 'Approx Benchmark Min', width: 200},
		{ field: 'approxBenchmarkMax', headerName: 'Approx Benchmark Max', width: 200},
		{ field: 'lastModifiedBy', headerName: 'Last Modified By', width: 200},		
		{ field: 'lastModifiedDateTime', headerName: 'Last Modified Date/Time', width: 200}
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	const handlePageChange = (newPage) => {
		setSelectedRow(0);
		setDataObj({});
		setPage(newPage);
		setFilter(!filter);
	  };

	React.useEffect(() => {		
		if(userObj.loginId && userObj.token){
			getApiData();
		}
	}, [userObj,filter]);
	
	async function getApiData(){
		///alert(userObj.token);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
			axios.get(env.API_URL+"/exams/read/test-patterns?minRows="+(page*pageSize)+"&maxRows="+pageSize+"&keyword="+keyword, axiosHeader) 
			   .then(response => {
				// alert("status >> "+response.status); 
			 	// alert("Just Checking >> "+JSON.stringify(response));
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					if(page===0){
						setRowCount(response.data.obj.rowCount);
					}
					setRows(response.data.obj.list);
					setPrivileges(response.data.obj.privileges);
				}		
			})
			// .catch((error) => {
			// 	alert("ERROR: ", error);
			// })	
	}

	function deleteData(){
		if(dataObj!=null && userObj.loginId && userObj.token){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'
				}
			}; 

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
				 
		  axios.post(env.API_URL+'/exams/delete/test-patterns', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage(dataObj.patternTitle+": test pattern has been deleted.");
					setRows(response.data.obj.list);	
					setDeleteDialogShow(false);
					setSelectedRow(0);
					setDataObj({});
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Test pattern could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("ERROR: ", error);
				})	
		}		
	
		
	}

	function saveData(opt){
		if(opt===1){
			setSelectedRow(0);
			setDataObj({});
			childRefNewSave.current.handleClickOpen();
		}else if((opt===2 || opt===6) && selectedRow>0 && dataObj && dataObj.autoId>0){
			if(opt===6){
				setClone(true);
			}else{
				setClone(false);
			}
			childRefNewSave.current.handleClickOpen();
		}else if(opt===3 && selectedRow>0 && dataObj && dataObj.autoId>0){
			childRefDetails.current.handleClickOpen();	
		}else if(opt===4 && selectedRow>0 && dataObj && dataObj.autoId>0){
			childRefSections.current.handleClickOpen();	
		}else if(opt===5 && selectedRow>0 && dataObj && dataObj.autoId>0){
			childRefDefinations.current.handleClickOpen();	
		}
	
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setFilter(!filter);
		setSelectedRow(0);
		setDataObj({});
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function updatedList(list) {
		setRows(list);
		setSelectedRow(0);
		setDataObj({});
	}

	return (
		<div> 
				<MetaTags>
            		<title>Test Patterns</title>
          		</MetaTags>
				
				<Header title='Test Patterns' />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>

									<FormControl style={{float:'left',width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									<Button onClick={() => {search()}} style={{float:'left', marginTop: 3}} size="small" variant="contained" color="secondary" >Search</Button>

									<div style={{float:'left', marginTop: 5}}>	
										{(privileges && privileges.length>0 && privileges.indexOf("create")>-1)?
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
										:null} 										
										{selectedRow>0?<>
											{(privileges && privileges.length>0 && privileges.indexOf("update")>-1)?<>
												<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
												<i onClick={()=>{saveData(6)}} title="Clone" className="fa fa-clone" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											</>:null}
											{(privileges && privileges.length>0 && privileges.indexOf("delete")>-1)?
												<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}	
											<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, color:'#0158dc', marginLeft:15, cursor:'pointer'}} />
											{/* {(dataObj && dataObj.sectionAllow)?
												<i onClick={()=>{saveData(4)}} title="Sections" className="fa fa-qrcode btncolor" style={{fontSize:25, color:'#0158dc', marginLeft:15, cursor:'pointer'}} />
  											:null}
											<i onClick={()=>{saveData(5)}} title="Pattern Definations" className="fa fa-object-group btncolor" style={{fontSize:22, color:'#0158dc', marginLeft:15, cursor:'pointer'}} /> */}

										</>:null}
									</div>

								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={pageSize}
							rowHeight={40}
							rowsPerPageOptions={[pageSize]}
							rowCount={rowCount}								
							paginationMode="server"
							onPageChange={handlePageChange}
  							loading={pageLoading}
							style={{fontSize:12}}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="30%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No data found!</span>
								  </Stack>
								)}}	
							onRowClick={itm => selectRow(itm)}	
						/>
					</div>

				</Box>

			<TestPatternSave clone={clone} dataObj={dataObj} ref={childRefNewSave} updatedList={updatedList} />
			<TestPatternDetails dataObj={dataObj} ref={childRefDetails} />
			<TestPatternSections dataObj={dataObj} ref={childRefSections} />
			<TestPatternDefinations dataObj={dataObj} ref={childRefDefinations} />						

			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

				<DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }